import { useEffect } from "react";
import ApplicationCooLayout from "../../layout/application-coo-layout";
import { useAppSelector } from "../../redux/hook";
import StageCMainColumn from "./stage-c-payment-main-column";
import { TextSubheader } from "../../components/text/text-subheader";
import { useInitialWindowScrollTo } from "../../hooks/use-initial-window-scroll-to";

const StageCPaymentLanding = () => {
  const startApplicationFormData = useAppSelector((state) => state.app.ApplicationStartSlice.formData);

  useInitialWindowScrollTo();

  return (
    <ApplicationCooLayout>
      <div className="polymer-stage-c-application-coo-wrapper">
        <TextSubheader
          subheaderMain="Stage C: Make Payment"
          subheaderSub={startApplicationFormData.selected_hdb_property?.address}
        />
        <StageCMainColumn />
      </div>
    </ApplicationCooLayout>
  );
};

export default StageCPaymentLanding;
